import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import ConsumoController from "../../../controllers/ConsumoController";
import { UseContextApp } from "../../../Global/Context/appContext";
import Spinner from "../../../components/Loading/loadingSpinner/Spinner";
import "../../../index.css";
import { IdentificationIcon, TableIcon } from "@heroicons/react/solid";
import banner from "../../../assets/Banners/NetUnoStreaming2.jpg";
import { colors } from "../../../propsType/Colors";
import { TabNavegation } from "../../../propsType/TabNavegation";
const Streamer = () => {
  const [{ user, consumoData }] = UseContextApp();
  const { consumo } = ConsumoController();
  const [Loading, setLoading] = useState(false);
  const [dataStreaming, setDataStreaming] = useState("");
  const location = useLocation();
  const pathName = location.pathname;
  const navigate = useNavigate();
  const { tabsHogar, tabsEmpresa } = TabNavegation(pathName)
  const [tabs, setTabs] = useState(user?.datos?.tipoCliente === "Hogar" ? tabsHogar : tabsEmpresa || [''])
  const getConsumo = async () => {
    if (!consumoData) {
      setLoading(true);
      const res = await consumo(user);
      if (res) {
        setLoading(false);
      }
    }
  };

  function handleChangeRouteCorpo(e) {
    let route = e.target.value;
    switch (route) {
      case "Servicios Internet":
        navigate("/cuenta/servicio-de-internet");
        break;
      case "Servicios Datos":
        navigate("/cuenta/servicio-de-datos");
        break;
      case "Servicios Televisión Streaming":
        navigate("/cuenta/servicio-de-streaming");
        break;
      case "Servicios Telefonía":
        navigate("/cuenta/servicio-de-telefonia");
        break;
      default:
        break;
    }
  }

  function handleChangeRoute(e) {
      let route = e.target.value;
    switch (route) {
      case "Servicios Internet":
        navigate("/cuenta/servicio-de-internet");
        break;
      case "Servicios Televisión":
        navigate("/cuenta/servicio-de-television");
        break;
      case "Servicios Televisión Streaming":
        navigate("/cuenta/servicio-de-streaming");
        break;
      case "Servicios Telefonía":
        navigate("/cuenta/servicio-de-telefonia");
        break;
      default:
        break;
    }
  }
  useEffect(() => {
    getConsumo();
    setDataStreaming(consumoData);
  }, [consumoData]);
  useEffect(() => {
  
  }, [dataStreaming]);
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        {Loading ? (
          <>
            <div className="w-full h-screen flex justify-center items-center ">
              <Spinner />
            </div>
          </>
        ) : (
          <>
            <div className="flex lg:w-full gap-5 px-4 overflow-auto flex-col">
              <BreadCrumbsGeneric locations={pathName} />
              <div>
                <div>
                  <div className="sm:hidden">
                    <label htmlFor="tabs" className="sr-only">
                      Select a tab
                    </label>
                    <select
                      id="tabs"
                      name="tabs"
                      onChange={user?.datos?.tipoCliente === "Hogar" ? handleChangeRoute : handleChangeRouteCorpo}
                      className="block w-full h-11 p-[10px] shadow focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                      defaultValue={tabs.find((tab) => tab.current)?.name}
                    >
                      {tabs?.map((tab) => (
                        <option key={tab?.name}>{tab?.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="hidden sm:block">
                    <nav
                      className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                      aria-label="Tabs"
                    >
                      {tabs.map((tab, tabIdx) => (
                        <Link
                          key={tab?.name}
                          to={tab.href}
                          className={classNames(
                            tab.current
                              ? "text-gray-900"
                              : "text-gray-500 hover:text-gray-700",
                            tabIdx === 0 ? "rounded-l-lg" : "",
                            tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                            "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                          )}
                          aria-current={tab.current ? "page" : undefined}
                        >
                          <span>{tab?.name}</span>
                          <span
                            aria-hidden="true"
                            className={classNames(
                              tab.current
                                ? `bg-[${colors.lightBlue}]`
                                : "bg-transparent",
                              "absolute inset-x-0 bottom-0 h-0.5"
                            )}
                          />
                        </Link>
                      ))}
                    </nav>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-[10px] py-5 lg:py-0 border-b border-gray-200 lg:px-0 px-6">
                <div className=" py-6 px-6 sm:px-6">
                  <div className="py-2 text-2xl font-medium ">
                    Servicios Televisión Streaming
                  </div>
                  <div className=" text-lg font-regular ">
                    Consulta el detalle de tus servicio, haz clic en
                    ver detalles
                  </div>
                </div>
                <div className="!m-0 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white rounded-[10px] gap-5 shadow-lg  mt-5 ">
                  {dataStreaming?.Streaming?.length > 0 ? (
                    <>
                      <div className="bg-white shadow overflow-hidden sm:rounded-md">
                        <ul role="list" className="divide-y divide-gray-200">
                          <div className=" hidden px-4 py-2 md:grid gap-4 lg:grid-cols-5 sm:px-6 border-b border-gray-200">
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Servicio
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Cuenta
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Contrato
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Estatus
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            ></div>
                          </div>
                          {dataStreaming?.Streaming?.map((streaming) => (
                            <Link
                              state={{ data: streaming }}
                              to={"/cuenta/servicio-de-streaming/detalle-streaming"}
                              className="group"
                            >
                              <li key={streaming.id}>
                                <div className="px-4 py-4 grid gap-4 lg:grid-cols-5 sm:px-6 group-hover:bg-gray-50">
                                  <div
                                    className={`text-sm text-start flex justify-center  items-end font-medium text-[${colors.lightBlue}]  truncate`}
                                  >
                                    {streaming.paquete}
                                  </div>
                                  <div>
                                    <div className="flex items-center gap-2 flex-col text-sm text-gray-500">
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Cuenta
                                      </div>
                                      <div className="flex">
                                        <IdentificationIcon
                                          className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                          aria-hidden="true"
                                        />
                                        {streaming.cuenta}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mt-2 flex gap-2  flex-col items-center text-sm text-gray-500 sm:mt-0">
                                    <div className="font-medium text-[14px] md:hidden block  ">
                                      Contrato
                                    </div>
                                    <div className="flex">
                                      <TableIcon
                                        className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                        aria-hidden="true"
                                      />
                                      {streaming.contrato}
                                    </div>
                                  </div>
                                  <div className=" flex w-full items-end justify-center">
                                    <div className="font-medium text-[14px] md:hidden block  ">
                                      Estatus
                                    </div>
                                    <p
                                      className={` ${streaming.status === "Conectado" ||
                                        streaming.status === "Conectado - S/Baja"
                                        ? "bg-green-100 text-green-800"
                                        : "bg-red-100 text-red-800"
                                        } px-2 inline-flex text-xs leading-5 font-semibold rounded-full `}
                                    >
                                      {streaming.status}
                                    </p>
                                  </div>
                                  <div className="flex items-end w-full justify-around ">
                                    <Link
                                      state={{ data: streaming }}
                                      to={
                                        "/cuenta/servicio-de-streaming/detalle-streaming"
                                      }
                                      className={`font-medium text-[${colors.lightBlue}]`}
                                    >
                                      Ver Detalles
                                    </Link>
                                  </div>
                                </div>
                              </li>
                            </Link>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="h-[20vh] flex justify-center items-center text-[1.3rem] font-semibold  ">
                        No posees servicios activos
                      </div>
                    </>
                  )}
                </div>
              </div>
              <img
                className=" rounded-[10px] shadow-lg img-banner-h "
                src={banner}
                alt=""
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Streamer;
